import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { BrandButton, BrandIconButton } from "components";
import { Close } from "@mui/icons-material";
import { Typography } from "components/Common/Typography/Typography";
import { colors } from "assets/colors/colors";
import "./dialog.scss";
import cn from "classnames";
import { Slide, styled, useMediaQuery, useTheme } from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  padding: "40px 32px 24px 32px",
  gap: "16px",
  [theme.breakpoints.down("md")]: {
    padding: "20px 16px 16px 16px",
  },
}));

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: "0 32px",
  [theme.breakpoints.down("md")]: {
    padding: "0 16px",
  },
}));

const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  padding: "32px",
  [theme.breakpoints.down("md")]: {
    padding: "16px",
    "& > button": {
      width: "100%",
    },
  },
}));

export const BrandDialog = ({
  open,
  onClose,
  submitButtonText = "Save",
  cancelButtonText = "Cancel",
  children,
  fullWidth = false,
  maxWidth = "sm",
  title,
  className,
  submitButtonProps,
  cancelButtonProps,
  fullScreen = false,
  content,
  ...props
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      className={cn("brand-dialog", {
        "brand-dialog_full-screen": fullScreen,
      })}
      slotProps={{ paper: { className: className } }}
      slots={fullScreen ? { transition: Transition } : undefined}
      fullScreen={fullScreen}
      {...props}
    >
      {children || (
        // TODO(anyone): consolidate confirms onto the custom BrandDialog
        // children layout (e.g. patient status / address modals) instead of
        // this title/content/actions slot API.
        <>
          <BrandDialogTitle
            title={title}
            onClose={onClose}
            fullScreen={fullScreen}
          />
          <StyledDialogContent>{content}</StyledDialogContent>
          <StyledDialogActions>
            <BrandButton
              variant="outlined"
              onClick={onClose}
              {...cancelButtonProps}
            >
              {cancelButtonText}
            </BrandButton>
            <BrandButton {...submitButtonProps}>{submitButtonText}</BrandButton>
          </StyledDialogActions>
        </>
      )}
    </Dialog>
  );
};

export const BrandDialogTitle = ({ title, fullScreen, onClose }) => {
  return (
    <StyledDialogTitle className="brand-dialog__title">
      <Title
        className="brand-dialog__title__title"
        fullScreen={fullScreen}
        title={title}
      />
      <BrandIconButton
        onClick={onClose}
        className="brand-dialog__title__close-button"
      >
        <Close />
      </BrandIconButton>
    </StyledDialogTitle>
  );
};

const Title = ({ title, fullScreen }) => {
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Typography
      variant={
        fullScreen
          ? isMediumScreen
            ? "h2_5"
            : "h1_75"
          : isMediumScreen
            ? "label"
            : "h3"
      }
      color={colors.core100}
      text={title}
    />
  );
};
